const renderShoppingCartCount = (shoppingCart) => {
	const cartCounts = Array.from(document.querySelectorAll('.shopping-cart-product-count-js'));
	cartCounts.forEach((cartCount) => {
		if (shoppingCart.cart_total > 0) {
			cartCount.innerHTML = shoppingCart.cart_total;
		} else {
			cartCount.innerHtml = '';
		}
	});
};

document.addEventListener('DOMContentLoaded', () => {
	reservationsApi.fetchShoppingCartCount(renderShoppingCartCount);
});
